import React from "react";
import "./css/TransactionTable.css";

const Transactiontable = (props) => {

    return (
        <>
            <div className="me-my-transactions-profile">
                <div className="me-my-transactions-head">
                    <div className="me-transactions-name">
                        <h4>LATEST INVESTORS</h4>
                    </div>
                </div>
                <div className="me-my-transactions-body table-responsive">
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Address</th>
                                <th>Investment</th>
                            </tr>
                        </thead>
                        {!props.isLoadingInvesters ? (
                            <tbody>
                                {props.icoInvestersList.map((invester, key) => (
                                    <tr key={invester.address + key}>
                                        <td>{invester.address}</td>
                                        <td>{parseInt(invester.balance)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        ) : (
                            <div>Loading...</div>
                        )}
                    </table>
                </div>
            </div>
        </>
    )
}

export default Transactiontable;